export enum MessageStatus {
    None = 0,
    Delivered = 1,
    Submitted = 2,
    Read = 3,
    Rejected = 4
}
